"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var store_1 = require("@ngrx/store");
var SkynetStoreFeatureModule = /** @class */ (function () {
    function SkynetStoreFeatureModule(features, featureReducers, reducerManager, root) {
        this.features = features;
        this.featureReducers = featureReducers;
        this.reducerManager = reducerManager;
        features
            .map(function (feature, index) {
            var featureReducerCollection = featureReducers.shift();
            var reducers = featureReducerCollection[index];
            return __assign({}, feature, { reducers: reducers, initialState: store_1._initialStateFactory(feature.initialState) });
        })
            .forEach(function (feature) { return reducerManager.addFeature(feature); });
    }
    SkynetStoreFeatureModule_1 = SkynetStoreFeatureModule;
    SkynetStoreFeatureModule.forFeature = function (featureName, reducers, config) {
        if (config === void 0) { config = {}; }
        return {
            ngModule: SkynetStoreFeatureModule_1,
            providers: [
                {
                    provide: store_1.STORE_FEATURES,
                    multi: true,
                    useValue: {
                        key: featureName,
                        reducerFactory: config.reducerFactory
                            ? config.reducerFactory
                            : store_1.combineReducers,
                        metaReducers: config.metaReducers
                            ? config.metaReducers
                            : [],
                        initialState: config.initialState,
                    },
                },
                { provide: store_1._FEATURE_REDUCERS, multi: true, useValue: reducers },
                {
                    provide: store_1._FEATURE_REDUCERS_TOKEN,
                    multi: true,
                    useExisting: reducers instanceof core_1.InjectionToken
                        ? reducers
                        : store_1._FEATURE_REDUCERS,
                },
                {
                    provide: store_1.FEATURE_REDUCERS,
                    multi: true,
                    deps: [
                        core_1.Injector,
                        store_1._FEATURE_REDUCERS,
                        [new core_1.Inject(store_1._FEATURE_REDUCERS_TOKEN)],
                    ],
                    useFactory: store_1._createFeatureReducers,
                },
            ],
        };
    };
    SkynetStoreFeatureModule.prototype.ngOnDestroy = function () { };
    SkynetStoreFeatureModule = SkynetStoreFeatureModule_1 = __decorate([
        core_1.NgModule({}),
        __param(0, core_1.Inject(store_1.STORE_FEATURES)),
        __param(1, core_1.Inject(store_1.FEATURE_REDUCERS)),
        __metadata("design:paramtypes", [Array, Array, store_1.ReducerManager,
            store_1.StoreRootModule])
    ], SkynetStoreFeatureModule);
    return SkynetStoreFeatureModule;
    var SkynetStoreFeatureModule_1;
}());
exports.SkynetStoreFeatureModule = SkynetStoreFeatureModule;
//# sourceMappingURL=skynet-store-feature.module.js.map